import {
  STORAGE_SHIPPING_V2_SOLICITACAO,
  STORAGE_SHIPPING_V2_YEAR,
} from "../constants/shippingV2Session";

export const AUTH_CHANGED_EVENT = "authChanged";

const KEY_TOKEN = "token";
const KEY_ACCESS_TOKEN = "accessToken";
const KEY_REFRESH_TOKEN = "refreshToken";
const KEY_USER = "user";
const KEY_PERFIL = "perfil";

function normalizeStoredValue(raw: string | null): string {
  return String(raw || "")
    .replace(/^"(.*)"$/, "$1")
    .trim();
}

export function emitAuthChanged(): void {
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function getStoredToken(): string {
  const raw =
    localStorage.getItem(KEY_ACCESS_TOKEN) || localStorage.getItem(KEY_TOKEN) || "";
  return normalizeStoredValue(raw);
}

export function getStoredRefreshToken(): string {
  return normalizeStoredValue(localStorage.getItem(KEY_REFRESH_TOKEN));
}

export function saveTokens(payload: {
  accessToken?: string;
  refreshToken?: string;
  token?: string;
}): void {
  const finalAccess = payload.accessToken || payload.token;

  if (finalAccess) {
    localStorage.setItem(KEY_TOKEN, finalAccess);
    localStorage.setItem(KEY_ACCESS_TOKEN, finalAccess);
  }

  if (payload.refreshToken) {
    localStorage.setItem(KEY_REFRESH_TOKEN, payload.refreshToken);
  }
}

export function saveAuthSession(payload: {
  accessToken?: string;
  refreshToken?: string;
  token?: string;
  user?: unknown;
  perfil?: unknown;
}): void {
  saveTokens(payload);

  if (payload.user !== undefined) {
    localStorage.setItem(KEY_USER, JSON.stringify(payload.user));
  }

  if (payload.perfil !== undefined) {
    localStorage.setItem(KEY_PERFIL, JSON.stringify(payload.perfil));
  }

  emitAuthChanged();
}

export function clearAuthSession(): void {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_ACCESS_TOKEN);
  localStorage.removeItem(KEY_REFRESH_TOKEN);
  localStorage.removeItem(KEY_USER);
  localStorage.removeItem(KEY_PERFIL);
  localStorage.removeItem("extract_filters_v2");
  localStorage.removeItem("extract_sindicato_filters_v1");

  sessionStorage.removeItem(KEY_TOKEN);
  sessionStorage.removeItem(KEY_ACCESS_TOKEN);
  sessionStorage.removeItem(KEY_REFRESH_TOKEN);
  sessionStorage.removeItem(KEY_USER);
  sessionStorage.removeItem(KEY_PERFIL);
  sessionStorage.removeItem(STORAGE_SHIPPING_V2_SOLICITACAO);
  sessionStorage.removeItem(STORAGE_SHIPPING_V2_YEAR);

  emitAuthChanged();
}
